"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePropertyObservable = exports.registerHandler = exports.Observable = void 0;
var components_1 = require("../../utils/components");
function Observable() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    /* eslint-enable @typescript-eslint/naming-convention, max-len */
    // Default options
    var options = {};
    // Implementation
    function decorator(target, name) {
        makePropertyObservable(target, name);
        if (options.callback) {
            var unregister_1 = registerHandler(target, name, function (value) {
                var _a;
                (_a = options.callback) === null || _a === void 0 ? void 0 : _a.call(this, value, unregister_1);
            });
        }
    }
    // Factory - use as @Observable({..})
    if (args.length == 1) {
        var arg = args[0];
        if (typeof arg == 'function') {
            options = {
                callback: arg,
            };
        }
        else {
            options = arg;
        }
        return decorator;
    }
    // Direct - use as @Observable
    var _a = __read(args, 2), target = _a[0], name = _a[1];
    return decorator(target, name);
}
exports.Observable = Observable;
// Implementation
var observableStateProperty = Symbol('observables');
var observableCallbacksProperty = Symbol('observableHandlers');
/** @internal */
function registerHandler(target, key, callback) {
    // Set up callbacks list on prototype, if not set up already
    var maybeInitialized = target;
    if (!maybeInitialized[observableCallbacksProperty]) {
        maybeInitialized[observableCallbacksProperty] = {};
    }
    var state = maybeInitialized;
    // Add callback to list
    if (!state[observableCallbacksProperty][key]) {
        state[observableCallbacksProperty][key] = [];
    }
    state[observableCallbacksProperty][key].push(callback);
    // Unregister callback
    var unregistered = false;
    return function () {
        if (unregistered) {
            return;
        }
        unregistered = true;
        var index = state[observableCallbacksProperty][key].indexOf(callback);
        state[observableCallbacksProperty][key].splice(index, 1);
    };
}
exports.registerHandler = registerHandler;
var OBSERVABLE_PROPERTY_TYPE_FLAG = Symbol('ObservableProperty');
/** @internal */
function makePropertyObservable(target, key) {
    // Check is property is already replaced
    var existingProperty = Object.getOwnPropertyDescriptor(target, key);
    if (existingProperty) {
        if (existingProperty.get.__type == OBSERVABLE_PROPERTY_TYPE_FLAG) {
            // This property was already replaced
            return;
        }
    }
    // Replace property with observable version
    delete target[key];
    var getFn = function get() {
        if (!this[observableStateProperty]) {
            this[observableStateProperty] = {};
        }
        return this[observableStateProperty][key];
    };
    getFn.__type = OBSERVABLE_PROPERTY_TYPE_FLAG; // Flag to identify that this has been replaced later
    var setFn = function set(value) {
        var e_1, _a;
        if (!this[observableStateProperty]) {
            this[observableStateProperty] = {};
        }
        var oldValue = this[observableStateProperty][key];
        if (oldValue === value) {
            // Already identical
            return;
        }
        this[observableStateProperty][key] = value;
        if ((0, components_1.isComponent)(this)) {
            if (!this.$isInit) {
                return;
            }
        }
        try {
            // Call all handlers
            for (var _b = __values(this[observableCallbacksProperty][key] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var handler = _c.value;
                handler.call(this, value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    setFn.__type = OBSERVABLE_PROPERTY_TYPE_FLAG;
    Object.defineProperty(target, key, {
        get: getFn,
        set: setFn,
        enumerable: true,
        configurable: true,
    });
}
exports.makePropertyObservable = makePropertyObservable;
//# sourceMappingURL=Observable.js.map